import { setUser } from '@sentry/react'
import { createContext, useCallback, useContext } from 'react'
import { noop } from 'rxjs'
import { saveSnapshotNow, useOpenFin } from '../helpers/hooks/useOpenFin'

/*
  While we could pass the signout function into App and then prop dril that into the menu and
  All Markets closed, I wasn't sure that would work well for OpenFin, so I'm doing it like this
 */
type SessionContextType = {
  signout: () => void
  editProfile?: () => void
}

export const SessionContext = createContext<SessionContextType>({
  signout: noop,
  editProfile: noop
})

export const useUserSession = () => {
  const { signout, editProfile } = useContext(SessionContext)
  const { finWindowAction, deregisterNotifications } = useOpenFin()

  const handleSignout = useCallback(() => {
    void (async () => {
      await saveSnapshotNow()
      await finWindowAction(null, 'hide', false, true)
      deregisterNotifications()

      signout()
      setUser(null)
    })()
  }, [signout, finWindowAction, deregisterNotifications])

  return {
    handleSignout,
    editProfile
  }
}
